import { render, staticRenderFns } from "./sidebarMenuItem.vue?vue&type=template&id=17098646&"
import script from "./sidebarMenuItem.vue?vue&type=script&lang=ts&"
export * from "./sidebarMenuItem.vue?vue&type=script&lang=ts&"
import style0 from "./sidebarMenuItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports